module.exports = "/images/breadcrumb-arrow-right-icon.svg?d5e9d315e940b098b509129767daac39";